import { h } from 'preact';
export const Video = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polygon", { points: "23 7 16 12 23 17 23 7" }),
        h("rect", { x: "1", y: "5", width: "15", height: "14", rx: "2", ry: "2" })));
};
//# sourceMappingURL=video.js.map